var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('episode-detail',{attrs:{"mode":"update","show-slug":_vm.showSlug,"episode-id":_vm.episodeId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }